
import Vue from "vue";
import {TicketService} from "@/services/ticket-service";
import {TicketMessage} from "@/models/ticket-message";
import {Ticket} from "@/models/ticket";

export default Vue.extend({
	data() {
		return {
			isSearching: false,
			currentTab: 0,
			search: "",
			messages: [] as TicketMessage[],
			tickets: [] as Ticket[],
		};
	},
	computed: {
		tabs(): string[] {
			let result = [
				"Tickets (" + this.tickets.length + ")",
				"Messages (" + this.messages.length + ")",
			];
			return result;
		},
	},
	methods: {
		close() {
			this.$emit("close");
		},
		timestamp(val: Date): string {
			let days = ["Zo", "Ma", "Di", "Woe", "Do", "Vr", "Za"];
			return days[val.getDay()] + ` ${val.getDate()}/${val.getMonth() + 1}/${val.getFullYear()} ${("0" + val.getHours()).slice(-2)}:${("0" + val.getMinutes()).slice(-2)}`;
		},
		async searchTickets() {
			this.messages = [];
			this.tickets = [];
			this.isSearching = true;
			let result = await TicketService.searchGlobal(this.search);
			result.messages.map((t: TicketMessage) => {
				t.content = t.content
					.replaceAll("<\/p>", "</p> ")
					.replace(/(<([^>]+)>)/gi, "")
					.replace(new RegExp(this.search, "gi"), match => {
						return '<span class="highlightText">' + match + "</span>";
					});
				//let position = t.content.indexOf("highlightText");
				//t.content = this.content.substr(position-15, position + 50);
				return t;
			});
			this.messages = result.messages;
			this.tickets = result.tickets;
		},
		onCancelSearch() {
			this.isSearching = false;
			this.search = "";
			this.messages = [];
			this.tickets = [];
			(this.$refs.search as any).focus();
		},
		openTicket(id: number) {
			window.open("/ticket/" + id + "?tab=0&page=1", "_blank");
		},
		getTicketCompanyName(ticket:Ticket):string{
			if (!ticket.company) return "";
			return ticket.company.name;
		},
		getTicketMessageCompanyName(message:TicketMessage):string{
			if (!message.ticket) return "";
			return this.getTicketCompanyName(message.ticket);
		}
	}
});
